const formLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
      "&.Mui-disabled": {
        color: theme.palette.text.primary,
        opacity: 1,
      },
    }),
  },
};

export default formLabel;
